<template>
  <transition name="open-menu">
    <div v-if="opened" class="side-menu-overlay" @click="close">
      <div class="side-menu" @click.stop>
        <header class="toolbar">
          <button class="menu-close" @click="close">
            <svgicon name="close" :alt="$t('close')" />
          </button>
        </header>
        <slot name="content" />
      </div>
    </div>
  </transition>
</template>
<script>
import '@/lib/icons/download';

export default {
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};

</script>

<style lang="scss" scoped>
  .menu-close {
    align-self: flex-end;
    color: $black;
    background: none;
    box-shadow: none;
    padding: 0.75rem 1rem;
    height: auto;
    line-height: 2rem;
    cursor: pointer;

    svg {
      fill: $pearl-500;
    }

    &:hover, &:active {
      svg { fill: $black; }
    }
  }

  .open-menu-enter-active,
  .open-menu-leave-active {
    transition: none 0.3s ease-in;
  }

  .side-menu-overlay {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    pointer-events: auto;
    z-index: 150;
  }

  .toolbar {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    border-bottom: 1px solid $neutral-100;
  }
  .open-menu-enter.side-menu-overlay,
  .open-menu-leave-to.side-menu-overlay {
    pointer-events: none;
  }

  .side-menu-overlay::after {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba($primary-300, 0.7);
    opacity: 1;
    will-change: opacity;
    pointer-events: auto;
    transition: opacity 0.3s ease-in;
  }

  .open-menu-enter.side-menu-overlay::after,
  .open-menu-leave-to.side-menu-overlay::after {
    opacity: 0;
    pointer-events: none;
  }

  .side-menu {
    position: relative;
    width: calc(100% - #{4rem});
    min-width: 20rem;
    height: 100%;
    padding: 0 0 2.25rem;
    background-color: $white;
    color: $black;
    box-shadow: 4px 0 40px rgba(0, 0, 0, 0.24);
    display: flex;
    flex-direction: column;
    transform: none;
    will-change: transform;
    z-index: 160;
    pointer-events: auto;
    transition: transform 0.3s ease;
    @media #{$screen-width-small} { width: 30%; }
  }

  .open-menu-enter .side-menu,
  .open-menu-leave-to .side-menu {
    transform: translateX(-103%);
  }

</style>
